/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/Name"
  
}) {
let requirementNameValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'name',
})
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="requirement.name"
 text={requirementNameValueData}
 color={dtTysiainputlabelColorPrimaryBase}
 size="medium"
 weight="semibold"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 marginRight={0}
 marginTop={0}
 display="block"
 width={200}
/>
{children}
</React.Fragment>)
}